import { render, staticRenderFns } from "./TopFlopSitesDashboard.vue?vue&type=template&id=54fe53cf&scoped=true&"
import script from "./TopFlopSitesDashboard.vue?vue&type=script&lang=js&"
export * from "./TopFlopSitesDashboard.vue?vue&type=script&lang=js&"
import style0 from "./TopFlopSitesDashboard.vue?vue&type=style&index=0&id=54fe53cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fe53cf",
  null
  
)

export default component.exports